import React from 'react';
import { createUseStyles } from 'react-jss';
import Logo from '~app/components/Survey/Logo';

const useStyles = createUseStyles({
  headerContainer: {
    width: 'auto',
  },
});

const Header = ({ logo }) => {
  const { headerContainer } = useStyles();
  return (
    <header className={headerContainer} data-testid="Header__Container">
      <Logo logo={logo} />
    </header>
  );
};

Header.propTypes = {
  logo: Logo.propTypes.logo,
};

Header.defaultProps = {
  logo: null,
};

export default Header;
